import { ButtonProps, Button } from '@cad-arc';
import React from 'react';
import classnames from 'classnames';

type ToggleOption<T> = { value: T; label: string; cssClasses: string[] };
export interface ToggleButtonProps<T = boolean> extends ButtonProps {
    options: [ToggleOption<T>, ToggleOption<T>];
    onToggle: (t: T) => void;
    state: T;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
    onToggle,
    options,
    state,
    className,
    ...rest
}) => {
    const isFirstOption = state === options[0].value;
    const { cssClasses, label } = options[isFirstOption ? 0 : 1];
    return (
        <Button
            {...rest}
            className={classnames(className, ...cssClasses)}
            onClick={() => {
                onToggle(isFirstOption ? options[1].value : options[0].value);
            }}
        >
            {label}
        </Button>
    );
};
